
export const common = {
  "home.awards.title": "受賞実績",
  "home.awards.pause": "受賞実績のスクロールを一時停止",
  "home.awards.play": "受賞実績のスクロールを再開",
  "home.awards.financialAlgorithm": "金融アルゴリズムのリーディング企業",
  "home.awards.asiaPacificGold": "アジア太平洋の金取引リーディングブランド",
  "home.awards.preciousMetals": "信頼される貴金属取引ブランド",
  "home.awards.digitalFinance": "デジタル金融の革新に貢献する企業",
  "home.awards.quantitativeTrading": "クオンツ取引技術の優秀企業",
 // ナビゲーション
'nav.home': 'ホーム',
'nav.trading': '取引',
'nav.markets': 'マーケット',
'nav.news': 'ニュース',
'nav.about': '会社概要',
'nav.contact': 'お問い合わせ',
'nav.login': 'ログイン',
'nav.register': '口座開設',


  // ヒーローセクション
'hero.title': '高品質な金・銀取引プラットフォーム',
'hero.subtitle': '香港で認可を受けた企業として、欧州投資家の皆様に安全で専門的な貴金属取引サービスを提供しております。',
'hero.cta.start': '取引を開始',
'hero.cta.learn': '詳細を見る',

// ホーム
'home.licenseHK': '香港認可取得',
'home.bankSec': '銀行レベルのセキュリティ',
'home.247s': '24時間年中無休のサポート',
'home.global': 'グローバルな視点',
'home.tradingPlat': '取引プラットフォーム',
'home.tradingWith': '堅実で信頼性の高い取引',
'home.exp': '貴金属取引のために設計された世界最高水準のプラットフォームを体験してください。MT5は機関投資家レベルのツール、高速な約定、そして包括的な市場分析を提供します。',
'home.dlMT5': 'MT5をダウンロード',
'home.watchDemo': 'デモを見る',

'home.tradingIns': '取引商品',
'home.exeSpeed': '約定スピード',
'home.mktAccess': '市場アクセス',
'home.uptime': '稼働率',
'home.allDevices': 'すべてのデバイスに対応',
'home.mktInt': 'マーケット情報',
'home.mktInt.desc': '貴金属市場に影響を与える経済イベントやニュースをリアルタイムで把握',
'home.lastUpdate': '最終更新',
'home.ecoCal': '経済カレンダー',
'home.refresh': '更新',
'home.currency': '通貨',
'home.events': 'イベント',
'home.previous': '前回',
'home.forecast': '予測',
'home.actual': '実績',
'home.mktNews': '市場ニュース',
'home.seeMore': 'さらに表示',
'home.ecoData': '経済データは複数の金融データ提供会社より提供されています • 市場ニュースは主要な金融メディアから配信されています',
'home.ac': '高度なチャート機能',
'home.pta': '80種類以上のテクニカル指標と分析ツールを備えた専門的なテクニカル分析',
'home.mpa': 'マルチプラットフォーム対応',
'home.tsa': 'デスクトップ、ウェブ、モバイルアプリでシームレスに取引可能',
'home.st': '安全な取引',
'home.bls': '銀行レベルの暗号化技術により、データ伝送と保存を安全に保護',
'home.247': '24時間市場アクセス',
'home.rtc': 'いつでもどこでも世界の貴金属市場にアクセスして取引可能',
'home.at': '自動売買',
'home.ea': 'エキスパートアドバイザー（EA）に対応し、アルゴリズム取引や自動取引戦略を実現',
'home.lfe': '超高速約定',
'home.ull': '極めて低遅延の注文執行で、競争力のあるスプレッドと迅速な取引を実現',


 // 特徴
'features.title': '当社プラットフォームを選ぶ理由',
'features.security.title': '銀行レベルのセキュリティ',
'features.security.desc': '高度な暗号化技術と多層的なセキュリティ体制により、お客様の資産を厳重に保護いたします。',
'features.licensed.title': '正式なライセンス取得',
'features.licensed.desc': '香港の金融当局の監督下で運営し、法令遵守と透明性を確保しております。',
'features.realtime.title': 'リアルタイム取引',
'features.realtime.desc': 'リアルタイムの市場データと瞬時の注文執行により、最適な取引機会を逃しません。',
'features.support.title': '24時間年中無休のサポート',
'features.support.desc': '多言語対応の専門チームが常時お客様をサポートいたします。',
'features.lmd': 'リアルタイム市場データ',
'features.rtp': '貴金属のリアルタイム価格',

// 市場
'markets.title': 'リアルタイム市場価格',
'markets.gold': 'ゴールド',
'markets.silver': 'シルバー',
'markets.platinum': 'プラチナ',
'markets.palladium': 'パラジウム',
'markets.price': '価格',
'markets.change': '変動',
'markets.high': '24時間高値',
'markets.low': '24時間安値',
'markets.contractDetials': '契約詳細',
'markets.contractDetials.desc': '貴金属取引に関する包括的な契約仕様と取引条件',
'markets.tradingExample': '取引例',
'markets.goldExample': 'ゴールド取引例',
'markets.silverExample': 'シルバー取引例',
'markets.instrument': '銘柄',
'markets.lotSize': 'ロットサイズ',
'markets.entPrice': 'エントリー価格',
'markets.marReq': '必要証拠金',
'markets.pip': 'ピップ値',
'markets.pmt': '貴金属取引',
'markets.ctt': '貴金属取引の契約条件、証拠金要件およびリスク管理について包括的にご理解ください。ゴールドおよびシルバー投資のための詳細情報を提供します。',
'markets.vts': '取引仕様を見る',
'markets.dcd': '契約詳細をダウンロード',
'markets.ec': '執行速度',
'markets.th': '取引時間',
'markets.ms': '最小スプレッド（pips）',
'markets.ml': '最大レバレッジ',
'markets.mr': '証拠金要件',
'markets.lo': '口座タイプ別のレバレッジと証拠金要件',
'markets.leverage': 'レバレッジ',
'markets.margin': '証拠金',
'markets.mind': '最低入金額',
'markets.mc': '証拠金計算機',
'markets.gmc': 'ゴールド証拠金計算',
'markets.cp': '現在価格',
'markets.cv': '契約価値',
'markets.smc': 'シルバー証拠金計算',
'markets.rm': 'リスク管理',
'markets.crm': 'お客様の投資を保護するための包括的なリスク管理ツールと戦略',
'markets.rtg': 'リスク許容度ガイド',
'markets.rd': 'リスク開示',
'markets.tpm': '貴金属取引には大きな損失リスクが伴い、すべての投資家に適しているとは限りません。過去の実績は将来の結果を保証するものではありません。',
'markets.lcw': 'レバレッジは利益を拡大させる一方で、損失も拡大させる可能性があります。取引を決定する前に、投資目的、経験、リスク許容度を十分にご検討ください。',
'markets.ysb': '貴金属取引に関わるすべてのリスクを十分に理解し、不明点がある場合は独立した金融アドバイザーにご相談ください。',
'markets.rfr': 'リスク開示全文を読む',
'markets.cra': 'リスクアドバイザーに連絡',
'markets.tho': '取引時間',
'markets.moh': '貴金属市場の取引時間および祝日スケジュール',
'markets.wts': '週間取引スケジュール',
'markets.note': '注意事項',
'markets.atad': 'すべての時間は GMT+8 で表示されています。主要な祝日または高ボラティリティ期間中は取引が一時停止される場合があります。',
'markets.hs': '祝日スケジュール',
'markets.mclo': '市場休場',
'markets.eclo': '早期クローズ',
'markets.hn': '祝日のお知らせ',
'markets.thm': '国民の祝日期間中は取引時間が変更される場合があります。スケジュールの変更については当社のお知らせをご確認ください。',
'markets.cms': '現在の市場状況',
'markets.mac': '市場は現在オープンしています',
'markets.st': 'サーバー時間（GMT+8）',
'markets.ts': '取引仕様',
'markets.dtc': 'ゴールドおよびシルバー商品の詳細な取引条件と仕様',
'markets.msp': '最小スプレッド',
'markets.minls': '最小ロットサイズ',
'markets.maxls': '最大ロットサイズ',
'markets.commission': '手数料',
'markets.sls': 'スワップ（金利・多/少）',
'markets.in': '重要事項',
'markets.smv': '高ボラティリティまたは重要ニュース発表時にはスプレッドが拡大する場合があります。',
'markets.sra': 'スワップ金利は毎日更新され、市場状況により変更される可能性があります。',
'markets.mlm': '重要なニュース発表時には最大レバレッジが一時的に制限される場合があります。',
'markets.ata': 'すべての時間は GMT+8 で表示されています。',


  // ニュース
'news.title': '最新の市場ニュースと分析',
'news.subtitle': '専門家の見解と市場動向を常に把握',
'news.readMore': '続きを読む',
'news.category.analysis': '市場分析',
'news.category.news': '速報ニュース',
'news.category.insights': '専門家の見解',
'news.category.education': '教育コンテンツ',
'news.date': '掲載日',
'news.author': '著者',

// お客様の声
'home.partners.title': 'パートナー',
'home.partners.subtitle': '世界をリードする流動性、フィンテック、取引インフラプロバイダーと連携しています。',
'testimonials.title': '世界中の投資家から信頼されています',
'testimonials.client1.name': 'マーカス・ウェーバー',
'testimonials.client1.location': 'ドイツ・フランクフルト',
'testimonials.client1.text': '価格が透明で、約定も確実です。セキュリティが高く安心して取引できます。',
'testimonials.client2.name': 'ソフィー・デュボワ',
'testimonials.client2.location': 'フランス・パリ',
'testimonials.client2.text': 'プロフェッショナルなサービスと競争力のあるスプレッド。多言語サポートチームの対応も素晴らしいです。',
'testimonials.client3.name': 'アレッサンドロ・ロッシ',
'testimonials.client3.location': 'イタリア・ミラノ',
'testimonials.client3.text': '約定が迅速で分析ツールも優秀。真剣に貴金属取引を行う方におすすめします。',

// フッター
'footer.company': '会社情報',
'footer.trading': '取引',
'footer.support': 'サポート',
'footer.legal': '法務',
'footer.about': '当社について',
'footer.careers': '採用情報',
'footer.news': 'ニュース',
'footer.platforms': '取引プラットフォーム',
'footer.education': '教育',
'footer.analysis': '市場分析',
'footer.help': 'ヘルプセンター',
'footer.contact': 'お問い合わせ',
'footer.faq': 'よくある質問',
'footer.terms': '利用規約',
'footer.privacy': 'プライバシーポリシー',
'footer.risk': 'リスク開示',
'footer.copyright': '© 2024 GOLD Label Global Limited. 全著作権所有。',
'footer.license': "香港で設立された会社",
'footer.riskwarning': 'リスク警告',
'footer.disclaimer': '証拠金取引はレバレッジを伴う金融商品であり、預託金を超える損失が発生する可能性があります。お客様は関連する原資産を実際に保有するものではありません。取引を開始する前に、当社の「リスク開示声明」をよくお読みください。すべてのリスクを十分に理解し、慎重にリスク管理を行ってください。本ウェブサイトの情報に基づく行為または不作為によって生じた損害について、当社は一切の責任を負いません。',
'footer.jurisdiction': "提供地域に関する重要なお知らせ",
'footer.jurisdictionDisclaimer': "本ウェブサイトに記載されたサービスは、香港および米国以外の法域に所在する適格なお客様に対し、お客様の所在地に適用される法令上その提供が認められている場合に限り提供されます。香港または米国の居住者、ならびに当該サービスの提供が違法または禁止されている法域の方にはサービスを提供していません。本ウェブサイトは制限対象法域の方を対象とするものではなく、そのような方に対する申込み、勧誘または推奨を構成するものではありません。",
'footer.relatedEntity': 'その他の関連法人',
'footer.saintLuciaEntity': 'Gold Label Global (SL) Limited は、2026年9月4日にセントルシアで設立された国際事業会社であり、会社登録番号は2026-00680です。登記上の事務所所在地：Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia。この登記上の事務所は、法令および規制上の遵守のみを目的として維持されており、会社の実際の営業拠点ではなく、事業運営、顧客の訪問または通信には使用されません。',
'footer.regNo': '会社登録番号',


  // 共通
'common.language': '言語',
'common.loading': '読み込み中…',
'common.error': 'エラー',
'common.success': '成功',
'common.close': '閉じる',
'common.save': '保存',
'common.cancel': 'キャンセル',
'common.continue': '続行',
'common.back': '戻る',
'common.next': '次へ',
'common.previous': '前のページ',
'common.submit': '送信',
'common.reset': 'リセット',

// 会社概要
'about.yearsOfExp': '長年の経験',
'about.yearsOfExp.desc': '貴金属取引分野で数十年にわたり蓄積された専門知識',
'about.dailyTrade': '一日あたりの取引量',
'about.dailyTrade.desc': '香港での金および銀の1日平均取引額は800億香港ドルに達します',
'about.satClients': '顧客満足度',
'about.satClients.desc': '世界中の個人および機関投資家から信頼を得ています',
'about.exeSpeed': '取引執行速度',
'about.exeSpeed.desc': '超高速の注文執行技術を採用',
'about.ourAch': '当社の実績',
'about.ourAch.desc': '業界をリードする成果で数々の評価を獲得',
'about.companyProfile': '会社概要',
'about.about1': 'Gold Label Globalについて',
'about.about2': 'Gold Label Global Limitedは香港政府により認可された有限会社であり、中国黄金白銀取引所のメンバーでもあります。香港では毎日約800億香港ドル相当の金・銀取引が行われ、当社は世界をリードする経験を有しています。',
'about.about3': 'Gold Label Globalの経営チームは、金・銀取引分野において20年以上の専門経験を有し、数多くの顧客および機関への取引支援を行い、累計取引額は数千億に達しています。その実績は業界内でも高く評価されています。',
'about.about4': '私たちはお客様に迅速かつ安定した高品質の取引環境を提供することに尽力しております。国際レベルの取引システムを採用し、トップレベルの技術チームがより強力で包括的な取引ソリューションを開発しています。',
'about.about5': 'Gold Label Globalは、お客様と共に利益を創出し、繁栄を分かち合うことを目指します。',
'about.about6': '当社の貴金属取引における成長の軌跡と、世界金融市場における卓越したパフォーマンスへの取り組みをご覧ください。',
'about.about7': '香港政府認可の有限会社および中国黄金白銀取引所のメンバーとして、当社は毎日約800億香港ドル規模の金・銀取引を取り扱っております。',
'about.proTeam': '専門チーム',
'about.proTeam.desc': '経営チームは金・銀取引分野で20年以上の経験を有し、多数の顧客および機関をサポートしています。',
'about.proService': '専門サービス',
'about.proService.desc': '専門的なカスタマーサポートチームが24時間オンライン対応し、お客様のニーズに合わせた最適なソリューションを提供します。',
'about.sec': '安全性第一',
'about.sec.desc': '取引の透明性を確保し、カウンターパーティリスクを排除。より安全で信頼性の高い取引を実現します。',
'about.strict': '厳格な監督体制',
'about.strict.desc': 'Gold Label Globalは香港の商業取引所として、香港政府の監督を受けて運営しており、香港商業取引協会のメンバーでもあります。',
'about.fastDes': '迅速な入金',
'about.fastDes.desc': '24時間体制の業務サービスにより、即時入金と即時利用を実現します。',
'about.productSafe': '商品安全',
'about.productSafe.desc': '世界主要貴金属商品を網羅し、安全で信頼できる取引環境を提供します。',
'about.whyGLB': 'Gold Label Globalを選ぶ理由',
'about.whyGLB.desc': '当社が貴金属取引分野でお客様の第一選択となる理由をご紹介します。',
'about.readyToStart': '取引を始める準備はできていますか？',
'about.join': '何千人ものお客様がGOLD Label Globalを信頼し、貴金属取引ニーズを満たしています。今すぐご参加ください。',
'about.openTradingAcc': '取引口座を開設',
'about.contactTeam': '当社チームにお問い合わせ',
'about.co': '協力と共栄',
'about.co.desc': 'お客様および関係者と互恵的で長期的なパートナーシップを構築',
'about.safety': '安全確保',
'about.safety.desc': 'すべての取引活動が最高水準の安全基準を満たすよう徹底管理',
'about.integrity': '誠実と信頼',
'about.integrity.desc': '最高水準の誠実さと透明性を堅持',
'about.professional': '専門性',
'about.professional.desc': '卓越した専門知識とサービス品質を提供',
'about.fast': '迅速性',
'about.fast.desc': '迅速な執行と即時対応のカスタマーサービスを提供',
'about.coreValue': '当社のコアバリュー',
'about.coreValue.desc': '貴金属取引分野における卓越性を追求するための基本指針',


// お問い合わせ
'contact.sendUsMsg': 'メッセージを送信',
'contact.fillOut': '以下のフォームにご記入ください。当社チームが24時間以内にご連絡いたします。',
'contact.inqType': 'お問い合わせ内容',
'contact.genInq': '一般的なお問い合わせ',
'contact.accSup': '口座サポート',
'contact.traSup': '取引サポート',
'contact.techSup': '技術サポート',
'contact.partner': 'パートナーシップ',
'contact.fullname': '氏名 *',
'contact.email': 'メールアドレス *',
'contact.phone': '電話番号',
'contact.subject': '件名 *',
'contact.msg': 'メッセージ *',
'contact.sendMsg': 'メッセージを送信',
'contact.whyUs': '当社を選ぶ理由',
'contact.regSec': '規制と安全性',
'contact.licAndReg': '規制された安全な取引環境を提供し、最先端のセキュリティ対策でお客様の資産を保護します。',
'contact.expSup': '専門家によるサポート',
'contact.proService': '経験豊富なトレーディングスペシャリストが24時間365日お客様の取引ニーズに対応いたします。',
'contact.fastExe': '高速な注文執行',
'contact.lightFast': '超高速の注文処理と極めて低いスリッページにより、最良の取引結果を実現します。',
'contact.glbNet': 'グローバル市場へのアクセス',
'contact.asscessToint': '国際的な貴金属市場へ直接接続し、競争力のあるスプレッドと高い流動性を提供します。',
'contact.followUs': 'ソーシャルメディアで当社をフォロー：',
'contact.contactOutPro': '取引サポート、口座関連、または一般的なお問い合わせについては、専門チームまでご連絡ください：',
'contact.officeAddress': 'オフィス所在地',
'contact.bussHour': '営業時間：月曜〜金曜 9:00〜18:00（GMT+8）',
'contact.phoneSupp': '電話サポート',
'contact.mainOffice': '本社オフィス',
'contact.availableServices': '提供サービス：',
'contact.accOpenSup': '口座開設サポート',
'contact.tradSup': '取引プラットフォームサポート',
'contact.genSup': '一般サポート',
'contact.emailSup': 'メールサポート',
'contact.responseTime': '応答時間：',
'contact.genInq24': '一般お問い合わせ：24時間以内',
'contact.techSup24': '技術サポート：4時間以内',
'contact.accIss24': '口座関連：2時間以内',
'contact.needImSup': '緊急サポートが必要ですか？',
'contact.needImSup.desc': '当社のトレーディングスペシャリストが24時間365日、緊急の取引および口座サポートに対応いたします。',
'contact.callNow': '今すぐ電話する',
'contact.sendEmail': 'メールを送信',
'contact.contactUs': 'お問い合わせ',
'contact.getInTouch': '当社の専門トレーディングチームにご連絡ください。貴金属取引の成功を全力でサポートいたします。',
'contact.247Sup': '24時間カスタマーサポート',
'contact.247Sup.desc': 'すべての取引ニーズに24時間体制で対応',
'contact.dirLine': '専用ダイヤル',
'contact.dirLine.desc': 'トレーディングスペシャリストと直接通話が可能',
'contact.hkOffice': '香港オフィス',
'contact.hkOffice.desc': '香港金融中心エリアに位置しています。',

// プラットフォーム
'platform.wco': 'なぜ当社のMT5プラットフォームを選ぶのか',
'platform.rts': '取引を始める準備はできていますか？',
'platform.jto': '何千人ものトレーダーが当社のプラットフォームを信頼し、貴金属取引を行っています。',
'platform.ola': 'リアル口座を開設',
'platform.tda': 'デモ口座を試す',

'platform.dmt': 'MT5プラットフォームをダウンロード',
'platform.ayt': 'MT5アプリを利用して、あらゆるデバイスで取引口座にアクセスおよび管理可能',
'platform.free': '無料',
'platform.dn': '今すぐダウンロード',
'platform.sr': 'システム要件',
'platform.nh': '導入サポートが必要ですか？',
'platform.os': '当社のサポートチームがセットアップと取引開始を丁寧にサポートいたします。',
'platform.ug': '利用ガイド',
'platform.cs': 'サポートに連絡',
'platform.si': '安定したインターネット接続が必要です',
'platform.ptf': '強力な取引機能',
'platform.epg': '初心者から専門トレーダーまで対応したプロフェッショナルツール',
'platform.ac': '高度なチャート',
'platform.pct': '80種類以上のテクニカル指標と複数の時間軸を備えたプロ向けチャートツールで市場を徹底分析。',
'platform.lfe': '超高速執行',
'platform.ull': '最速0.01秒の低遅延取引で、正確なエントリーとイグジットを実現。',
'platform.ea': '自動売買（EA）',
'platform.atc': 'カスタムEAおよびアルゴリズム戦略に対応した自動取引機能。',
'platform.rm': 'リスク管理',
'platform.crm': '損切・利確・ポジションコントロールなど、包括的なリスク管理ツールを提供。',
'platform.mpa': 'マルチプラットフォーム対応',
'platform.tsa': 'デスクトップ、ウェブ、モバイルの各プラットフォームでシームレスに取引可能。',
'platform.gm': 'グローバル市場',
'platform.ati': '貴金属、為替、指数、コモディティなどの国際市場にアクセス可能。',
'platform.etw': '世界最先端の取引プラットフォームを体験。機関投資家レベルの技術と高速執行で、貴金属・為替・CFD取引をサポート。',
'platform.download': 'ダウンロード ',
'platform.wd': 'デモを見る',
'platform.es': '執行速度',
'platform.th': '取引時間',
'platform.in': '取引商品',
'platform.lt': 'リアル取引',
'platform.ptt': 'プロ向け取引ツール',
'platform.aig': 'プロフェッショナルおよび真剣な投資家向けに設計された機関投資家レベルのツール',
'platform.rtd': 'リアルタイムデータ',
'platform.lmd': '市場データと価格更新をリアルタイムで提供',
'platform.pa': '価格アラート',
'platform.caf': '価格変動や市場イベントをカスタマイズして通知',
'platform.this': '取引履歴',
'platform.cth': '完全な取引履歴とパフォーマンス分析を閲覧可能',
'platform.ec': '経済カレンダー',
'platform.suw': '重要な経済イベントを常に把握',

'platform.mw': '市場価格',
'platform.rtp': 'すべての取引可能な銘柄のリアルタイム価格と市場深度',
'platform.om': '注文管理',
'platform.aot': '成行・指値・逆指値・トレーリングストップなどの注文形式に対応',
'platform.ta': 'テクニカル分析',
'platform.cta': 'カスタム指標や描画ツールを備えた完全な分析スイート',
'platform.ffd': 'Windows 10/11 用のフル機能デスクトップアプリケーション',
'platform.nma': 'すべての機能を備えたネイティブ macOS アプリケーション',
'platform.mta': 'Android デバイス向けのモバイル取引アプリ',
'platform.iai': 'iPhone と iPad 向けの取引アプリ',

'faq.tagline': '[translate:どのようにお手伝いできますか？]',
'faq.title': '[translate:どのようにお手伝いできますか？]',
'faq.subtitle': '[translate:包括的なFAQセクションから、よくある質問への迅速な回答を見つけてください。]',
'faq.categories': '[translate:カテゴリー]',
'faq.cantFind': '[translate:お探しの情報が見つかりませんか？]',
'faq.supportText': '[translate:FAQに記載されていない質問については、サポートチームが対応いたします。]',
'faq.contactSupport': '[translate:サポートチームに連絡する]',

'faq.general': '[translate:一般]',
'faq.account': '[translate:アカウント]',
'faq.trading': '[translate:取引]',
'faq.platform': '[translate:プラットフォーム]',
'faq.deposits': '[translate:入金・出金]',
'faq.security': '[translate:セキュリティ]',

'faq.general.q1': '[translate:GOLD LABEL GLOBAL LIMITEDとは何ですか？]',
'faq.general.a1': '[translate:GOLD LABEL GLOBAL LIMITEDは、香港に拠点を置く規制された貴金属取引会社であり、MT5プラットフォームを通じて金、銀、その他の貴金属の専門取引サービスを提供しています。]',
'faq.general.q2': '[translate:どのような取引商品を提供していますか？]',
'faq.general.a2': '[translate:当社はスポットゴールド（XAU/USD）、スポットシルバー（XAG/USD）、プラチナ、パラジウム、その他の貴金属先物契約など、幅広い貴金属商品を取り扱っています。]',
'faq.general.q3': '[translate:取引時間を教えてください。]',
'faq.general.a3': '[translate:貴金属市場は国際市場時間に合わせて、日曜午後5時（EST）から金曜午後4時（EST）まで、週5日24時間営業しています。]',
'faq.general.q4': '[translate:投資は安全ですか？]',
'faq.general.a4': '[translate:はい。当社は完全に規制され、ライセンスを取得しています。お客様の資金は分別管理された安全な銀行口座にて保管され、包括的な保険も加入しています。]',

'faq.account.q1': '[translate:取引口座を開設するにはどうすればいいですか？]',
'faq.account.a1': '[translate:オンライン申請フォームの記入、本人確認書類の提出、および初回入金を行うことで口座を開設できます。通常、処理には1〜2営業日かかります。]',
'faq.account.q2': '[translate:最低入金額はいくらですか？]',
'faq.account.a2': '[translate:標準口座の最低入金額は1,000米ドルです。より多くの特典を備えたプレミアム口座もご用意しています。]',
'faq.account.q3': '[translate:複数の取引口座を持つことは可能ですか？]',
'faq.account.a3': '[translate:はい。異なる基本通貨や口座タイプで複数の取引口座を開設し、戦略やリスク管理の目的に応じて使い分けることができます。]',
'faq.account.q4': '[translate:口座の認証はどのように行いますか？]',
'faq.account.a4': '[translate:政府発行のID（パスポートまたは運転免許証）および3か月以内の日付の住所確認書類（公共料金請求書または銀行明細書）が必要です。]',

'faq.trading.q1': '[translate:最小取引単位はいくつですか？]',
'faq.trading.a1': '[translate:ほとんどの貴金属取引商品では、最小取引単位は0.01ロットです。これにより、柔軟なポジションサイズとリスク管理が可能になります。]',
'faq.trading.q2': '[translate:どの程度のレバレッジを提供していますか？]',
'faq.trading.a2': '[translate:貴金属取引に対して最大1:100の競争力あるレバレッジを提供しています。]',
'faq.trading.q3': '[translate:取引手数料はありますか？]',
'faq.trading.a3': '[translate:当社はスプレッドベースの方式を採用しており、手数料はかかりません。スプレッドは競争的かつ透明です。]',
'faq.trading.q4': '[translate:自動売買は利用できますか？]',
'faq.trading.a4': '[translate:はい。MT5プラットフォームはExpert Advisor（EA）および自動売買戦略に完全対応しています。]',

'faq.platform.q1': '[translate:どの取引プラットフォームをサポートしていますか？]',
'faq.platform.a1': '[translate:当社は主にMetaTrader 5（MT5）を使用しています。MT5はデスクトップ（Windows/Mac）、モバイル（iOS/Android）、およびWeb版で利用可能です。]',
'faq.platform.q2': '[translate:MT5プラットフォームは無料ですか？]',
'faq.platform.a2': '[translate:はい。MT5は無料でダウンロードして使用できます。すべての機能、チャート、インジケーターを追加料金なしで利用可能です。]',
'faq.platform.q3': '[translate:モバイル取引は可能ですか？]',
'faq.platform.a3': '[translate:もちろんです。MT5のモバイルアプリ（iOSおよびAndroid）でリアルタイムチャートや市場ニュース、口座管理が行えます。]',
'faq.platform.q4': '[translate:デモ口座はありますか？]',
'faq.platform.a4': '[translate:はい。仮想資金を使って取引を練習できる無料デモ口座を提供しています。]',

'faq.deposits.q1': '[translate:どの入金方法が利用できますか？]',
'faq.deposits.a1': '[translate:銀行送金、クレジット／デビットカード（Visa、MasterCard）、および各種電子決済に対応しています。すべて安全かつ迅速に処理されます。]',
'faq.deposits.q2': '[translate:入金処理にはどのくらい時間がかかりますか？]',
'faq.deposits.a2': '[translate:クレジットカードは即時反映され、銀行送金は1〜3営業日かかります。電子決済は数時間以内に処理されることが多いです。]',
'faq.deposits.q3': '[translate:入金手数料はありますか？]',
'faq.deposits.a3': '[translate:当社はほとんどの入金方法で手数料を請求しません。ただし、ご利用の銀行または決済プロバイダにより手数料が発生する場合があります。]',
'faq.deposits.q4': '[translate:資金を出金するには？]',
'faq.deposits.a4': '[translate:クライアントポータルから出金リクエストを送信できます。資金は原則として入金時と同じ方法で返金されます。]',

'faq.security.q1': '[translate:個人情報はどのように保護されていますか？]',
'faq.security.a1': '[translate:すべてのデータ通信はSSL256ビット暗号化で保護されています。個人情報は安全に保管され、同意なしに第三者と共有されません。]',
'faq.security.q2': '[translate:二要素認証（2FA）は利用できますか？]',
'faq.security.a2': '[translate:はい。アカウントの安全性を向上させるため、2FAの有効化を強く推奨します。]',
'faq.security.q3': '[translate:パスワードを忘れた場合は？]',
'faq.security.a3': '[translate:ログインページの「パスワードをお忘れですか」リンクからリセットできます。安全なリンクがメールで送信されます。]',
'faq.security.q4': '[translate:公正な取引環境はどう保証されていますか？]',
'faq.security.a4': '[translate:リアルタイム市場データ、ノーディーリングデスクポリシー、厳格な規制準拠を通して、公正で透明な取引環境を提供しています。]',

'hero.browseFAQ': '[translate:FAQを見る]',
'hero.contactSupport': '[translate:サポートに連絡する]',

'contactCTA.phoneTitle': '[translate:電話サポート]',
'contactCTA.phoneDesc': '[translate:専門スタッフと直接話す]',
'contactCTA.callNow': '[translate:今すぐ電話する]',
'contactCTA.emailTitle': '[translate:メールサポート]',
'contactCTA.emailDesc': '[translate:詳細な回答をメールで受け取る]',
'contactCTA.sendMsg': '[translate:メッセージを送信]',
'contactCTA.chatTitle': '[translate:ライブチャット]',
'contactCTA.chatDesc': '[translate:即時メッセージサポート]',
'contactCTA.available': '[translate:24時間対応]',
'contactCTA.startChat': '[translate:チャットを開始する]',
'contactCTA.title': '[translate:まだお困りですか？]',
'contactCTA.subtitle': '[translate:当社のサポートチームが24時間体制でお客様をサポートいたします。]',

'markets.specsTitle': '貴金属およびFX取引ルール',
'markets.specsDisclaimer': '* 取引条件は、プラットフォーム設定および市場流動性により変更される場合があります。',
'markets.spreadTypeFloating': '変動スプレッド',
'markets.points': 'ポイント',
'markets.variableByMarket': '市場状況により変動',

'markets.table.symbol': '銘柄',
'markets.table.contractUnit': '契約単位',
'markets.table.minLot': '最小取引量',
'markets.table.maxLot': '最大取引量',
'markets.table.leverage': 'レバレッジ',
'markets.table.spreadType': 'スプレッドタイプ',
'markets.table.avgSpread': '平均スプレッド',
'markets.table.swapLong': 'スワップ（買い）',
'markets.table.swapShort': 'スワップ（売り）',
'markets.contractSections.contractSize.title': '契約サイズ',
'markets.contractSections.contractSize.items.xauusd.label': '金 (XAUUSD)',
'markets.contractSections.contractSize.items.xauusd.desc': '金取引の標準契約サイズ',
'markets.contractSections.contractSize.items.xagusd.label': '銀 (XAGUSD)',
'markets.contractSections.contractSize.items.xagusd.desc': '銀取引の標準契約サイズ',
'markets.contractSections.contractSize.items.gaucnh.label': 'GAUCNH',
'markets.contractSections.contractSize.items.gaucnh.desc': 'オフショア人民元関連FX取引の標準契約サイズ',

'markets.contractSections.priceMove.title': '最小価格変動',
'markets.contractSections.priceMove.items.goldTick.label': '金の最小値幅',
'markets.contractSections.priceMove.items.goldTick.desc': '最小価格変動単位',
'markets.contractSections.priceMove.items.silverTick.label': '銀の最小値幅',
'markets.contractSections.priceMove.items.silverTick.desc': '最小価格変動単位',
'markets.contractSections.priceMove.items.fxTick.label': 'FXの最小値幅',
'markets.contractSections.priceMove.items.fxTick.desc': '通貨ペア価格の最小変動単位',

'markets.contractSections.settlement.title': '決済方法',
'markets.contractSections.settlement.items.type.label': '決済タイプ',
'markets.contractSections.settlement.items.type.value': '現金決済',
'markets.contractSections.settlement.items.type.desc': '現物受渡しは不要です',
'markets.contractSections.settlement.items.currency.label': '決済通貨',
'markets.contractSections.settlement.items.currency.desc': '貴金属商品は米ドルで決済されます',
'markets.contractSections.settlement.items.fxQuote.label': '建値通貨',
'markets.contractSections.settlement.items.fxQuote.desc': 'GAUCNH は CNH 建てで表示されます',

'markets.contractSections.positionLimits.title': 'ポジション制限',
'markets.contractSections.positionLimits.items.maxPosition.label': '最大ポジション',
'markets.contractSections.positionLimits.items.maxPosition.desc': '口座ごとの銘柄別上限',
'markets.contractSections.positionLimits.items.orderDistance.label': '注文距離',
'markets.contractSections.positionLimits.items.orderDistance.desc': '市場価格からの最小距離',
'markets.contractSections.positionLimits.items.execution.label': '執行方式',
'markets.contractSections.positionLimits.items.execution.value': '成行執行',
'markets.contractSections.positionLimits.items.execution.desc': '注文は市場流動性に応じて執行されます',

'markets.days.monday': '月曜日',
'markets.days.tuesday': '火曜日',
'markets.days.wednesday': '水曜日',
'markets.days.thursday': '木曜日',
'markets.days.friday': '金曜日',
'markets.days.saturday': '土曜日',
'markets.days.sunday': '日曜日',

'markets.hours.monThu': '06:00 - 04:59',
'markets.hours.friday': '06:00 - 04:57',
'markets.hours.closed': '休場',

'markets.holidays.newYear.date': '1月1日',
'markets.holidays.newYear.event': '元日',
'markets.holidays.christmas.date': '12月25日',
'markets.holidays.christmas.event': 'クリスマス',
'markets.holidays.independence.date': '7月4日',
'markets.holidays.independence.event': '独立記念日（米国）',
'markets.holidays.thanksgiving.date': '11月24日',
'markets.holidays.thanksgiving.event': '感謝祭（米国）',
"hero.cta.accountOpening": "口座開設ガイド",
"hero.cta.depositWithdraw": "入出金ガイド"
,
  "androidDownload.title": "MetaTrader 5 をダウンロード",
  "androidDownload.description": "まもなく Google Play に自動で移動します。端末で Google Play を利用できない場合は、APK を直接ダウンロードできます。",
  "androidDownload.autoRedirect": "{{seconds}} 秒後に Google Play へ移動します",
  "androidDownload.openGooglePlay": "Google Play を開く",
  "androidDownload.downloadApk": "APK を直接ダウンロード",
  "androidDownload.hint": "Google Play が開かない場合は、「APK を直接ダウンロード」をタップしてください。",
  'windowsDownload.pageTitle': 'Windows MT5 ダウンロード',
  'windowsDownload.pageDesc': '適切なインストーラーを選択してください。',
  'windowsDownload.badge': 'Windows MT5 ダウンロード',
  'windowsDownload.title': 'インストーラーを選択してください',
  'windowsDownload.description': 'Windows MT5 インストーラーを選択してください。Gold Label Smooth Stable Version は中国本土および香港のユーザーに推奨されます。公式インストーラーも選択できます。',
  'windowsDownload.smoothTitle': '1. Gold Label Smooth Stable Version',
  'windowsDownload.smoothDesc': '中国本土 / 香港の Windows ユーザーに推奨されます。公式インストーラーが利用しづらい場合、他地域のユーザーも利用できます。',
  'windowsDownload.smoothButton': 'Gold Label Smooth Stable Version をダウンロード',
  'windowsDownload.officialTitle': '2. MetaQuotes 公式インストーラー',
  'windowsDownload.officialDesc': '元のダウンロードリンクです。中国本土の Windows ユーザーはまれにインストールできない場合がありますが、他地域のユーザーには影響ありません。',
  'windowsDownload.officialButton': '公式インストーラーをダウンロード',

  // Economic calendar explorer
  'calendar.hongKongTime': '香港時間（GMT+8）',
  'calendar.previousDays': '前の7日間',
  'calendar.nextDays': '次の7日間',
  'calendar.today': '今日',
  'calendar.jumpToDate': '日付へ移動',
  'calendar.completeView': '完全表示',
  'calendar.allDays': '7日間すべて',
  'calendar.events': '件',
  'calendar.impactAll': '重要度すべて',
  'calendar.impactHigh': '高',
  'calendar.impactMedium': '中',
  'calendar.impactLow': '低',
  'calendar.searchPlaceholder': 'イベント、国、通貨を検索',
  'calendar.eventsFound': '件を表示',
  'calendar.lastUpdated': '最終更新',
  'calendar.loadError': '経済カレンダーを一時的に読み込めません。',
  'calendar.noEvents': 'この表示に一致する経済イベントはありません。',
  'calendar.tryAnotherDate': '別の日付を選択するか、フィルターを解除してください。',
  'calendar.time': '時刻',
  'calendar.impact': '重要度',
  'calendar.released': '発表済み',
  'calendar.pending': '未発表',
  'calendar.disclaimer': '時刻は香港時間です。数値は修正される場合があり、情報提供のみを目的としています。',
  'news.tab.newsDesc': '最新の市場ニュース、金分析、教育コンテンツ',
  'news.tab.calendarDesc': '前後の日付の重要な経済イベントと発表値を確認',
  'news.autoRefresh': 'ニュース情報は自動的に更新されます',

  'news.tabs.news': 'ニュース',
  'news.tabs.calendar': '経済カレンダー',

};

export default common;
